module.exports = __webpack_public_path__ + "img/scripted.9354ff58.svg";